import type { StarterDashboardV2ShareRecommendationsQuery } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { EXECUTORS } from '../hooks/actions/executors';
import type { ActionsReturnType } from '../hooks/actions/types';

import type { FullPostType, SharingModalFactoryProps } from './types';

type ReadyToShareData = {
	readyToSharePostsValue?: Array<{
		platform: string;
		message: string | null;
		images: Array<{ url: string }>;
	}>;
	isLoading: boolean;
};

type RecommendedGroup = StarterDashboardV2ShareRecommendationsQuery['shareRecommendations'][
	| 'facebook'
	| 'reddit'][number];

export function useActionsFactory(props: SharingModalFactoryProps, dynamicData: ReadyToShareData): ActionsReturnType {
	let recommendedGroup: RecommendedGroup | undefined;
	const { platform, postType } = props;

	if ('recommendedGroup' in props) {
		recommendedGroup = props.recommendedGroup as RecommendedGroup;
	}

	const fullPostType = `${platform}${recommendedGroup ? '_group' : ''}_${postType}` as FullPostType;

	const sharingData = dynamicData.readyToSharePostsValue?.find((post) => {
		if (platform === 'facebook' && recommendedGroup) {
			return post.platform === 'FACEBOOKGROUPS';
		}
		if (platform === 'facebook') {
			return post.platform === 'FACEBOOK';
		}
		if (platform === 'instagram') {
			return post.platform === 'INSTAGRAM';
		}
		return post.platform === 'REDDIT';
	});

	const sharingResource = sharingData
		? {
				message: sharingData.message || '',
				previewImageUrl: sharingData.images[0]?.url || '',
				shareUrl: recommendedGroup?.url || '',
			}
		: undefined;

	// Add sharingResource to props for executors
	const propsWithSharingResource = {
		...props,
		sharingResource,
	};

	return EXECUTORS[fullPostType](propsWithSharingResource);
}
